export default (kasko) => {
  kasko.addEventListener(
    'state-changed',
    (policyEndDate) => {
      if (policyEndDate === '') {
        kasko.dispatchEvent('set-state-input', {
          policy_end_date_human: null,
        });
        kasko.dispatchEvent('set-form-input', {
          policy_end_date_human: null,
        });
      }
    },
    {
      slice: 'input.policy_end_date_human',
    },
  );
};
